export const defaultSeoAreas = [
  { name: 'Tecnologia' },
  { name: 'Marketing' },
  { name: 'Conteúdo' },
  { name: 'SEO' },
  { name: 'Produto' },
  { name: 'Design' },
  { name: 'Mídia' },
  { name: 'Outros' },
];
